import { ViewType } from "@common/types/views/views";
import {
    InvoiceView,
    InvoicesByCustomerView,
    InvoiceColumn,
    InvoicesByCustomerColumn,
    InvoiceLineItemView,
    InvoiceLineItemColumn,
} from "@common/types/views/invoiceViews";

export const defaultInvoicesView: InvoiceView = {
    type: ViewType.INVOICE,
    columns: [
        { id: InvoiceColumn.LOCK, options: { pin: "left" } },
        { id: InvoiceColumn.DATE, options: { pin: "left" } },
        { id: InvoiceColumn.EXTERNAL_STATUS },
        { id: InvoiceColumn.INVOICE_NUMBER },
        { id: InvoiceColumn.CUSTOMER },
        { id: InvoiceColumn.ACCOUNT },
        { id: InvoiceColumn.INVOICE_DATE },
        { id: InvoiceColumn.DUE_DATE },
        { id: InvoiceColumn.AMOUNT },
        { id: InvoiceColumn.PAID },
        { id: InvoiceColumn.MATCH },
        { id: InvoiceColumn.ENTITY, options: { pin: "right" } },
        { id: InvoiceColumn.EXTERNAL_LINK, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: true,
        bulkActions: true,
    },
};

export const invoiceTemplateSourcePickerView: InvoiceView = {
    type: ViewType.INVOICE,
    columns: [
        { id: InvoiceColumn.DATE, options: { pin: "left" } },
        { id: InvoiceColumn.EXTERNAL_STATUS },
        { id: InvoiceColumn.INVOICE_NUMBER },
        { id: InvoiceColumn.CUSTOMER },
        { id: InvoiceColumn.ACCOUNT },
        { id: InvoiceColumn.DUE_DATE },
        { id: InvoiceColumn.AMOUNT },
        { id: InvoiceColumn.ENTITY, options: { pin: "right" } },
        { id: InvoiceColumn.SELECT, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

export const createDefaultInvoiceLineItemsView = ({
    hasAnyAccrualLedgers,
}: {
    hasAnyAccrualLedgers: boolean;
}): InvoiceLineItemView => ({
    type: ViewType.INVOICE_LINE_ITEM,
    columns: [
        { id: InvoiceLineItemColumn.LOCK, options: { pin: "left" } },
        { id: InvoiceLineItemColumn.DATE, options: { pin: "left" } },
        { id: InvoiceLineItemColumn.EXTERNAL_STATUS },
        { id: InvoiceLineItemColumn.CUSTOMER },
        { id: InvoiceLineItemColumn.ITEM },
        { id: InvoiceLineItemColumn.KIND },
        { id: InvoiceLineItemColumn.DESCRIPTION },
        { id: InvoiceLineItemColumn.ACCRUAL_ACCOUNT },
        ...(hasAnyAccrualLedgers
            ? [{ id: InvoiceLineItemColumn.ACCOUNTS_RECEIVABLE as const }]
            : []),
        { id: InvoiceLineItemColumn.DUE_DATE },
        { id: InvoiceLineItemColumn.ACCOUNT },
        { id: InvoiceLineItemColumn.AMOUNT },
        { id: InvoiceLineItemColumn.ENTITY, options: { pin: "right" } },
        { id: InvoiceLineItemColumn.EXTERNAL_LINK, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: true,
        bulkActions: true,
    },
});

export const defaultInvoiceLineItemsView: InvoiceLineItemView =
    createDefaultInvoiceLineItemsView({ hasAnyAccrualLedgers: false });

export const defaultInvoicesByCustomerView: InvoicesByCustomerView = {
    type: ViewType.INVOICES_BY_CUSTOMER,
    columns: [
        { id: InvoicesByCustomerColumn.CUSTOMER },
        { id: InvoicesByCustomerColumn.CURRENT },
        { id: InvoicesByCustomerColumn.PAST_DUE_1_TO_30 },
        { id: InvoicesByCustomerColumn.PAST_DUE_31_TO_60 },
        { id: InvoicesByCustomerColumn.PAST_DUE_61_TO_90 },
        { id: InvoicesByCustomerColumn.PAST_DUE_91_PLUS },
        { id: InvoicesByCustomerColumn.TOTAL_OPEN, options: { pin: "right" } },
        { id: InvoicesByCustomerColumn.TOTAL_PAID, options: { pin: "right" } },
        {
            id: InvoicesByCustomerColumn.INVOICES_COUNT,
            options: { pin: "right" },
        },
        { id: InvoicesByCustomerColumn.ENTITIES, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
    },
};
